import { TWO_DIGITS } from '../constants/timeConstants';

export default function transformDigits(digits) {
    return digits < TWO_DIGITS ? "0" + digits : digits;
}